import { Spinner } from "react-bootstrap";

export default function Loading({fullloader}) {
    return (
        <div className={`preloader ${fullloader?fullloader:""}`}><div className="preloader-inner"><Spinner animation="border" /></div></div>
    );
}